import React from 'react';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

export const EventCardSkeleton = () => {
    return (
        <Box height={90} width={104} alignItems="center" justifyContent={'center'}>
            <Box backgroundColor={ds.colorToken.background.neutral.subtler} borderRadius={'r16'}>
                <LoadingSkeleton
                    skeletonColor={designSystem.colors.neutral300}
                    width={104}
                    height={90}
                    borderRadius={'r16'}
                />
            </Box>
        </Box>
    );
};
